import React, { useRef, useState } from "react";
import { Icon, SelectField } from "@culturehq/components";

import { useValues } from "app/context";
import { t } from "app/utils";

const RecognizeAddValue = ({ onValueSelected }) => {
  const { organizationValues, onAllOrganizationValuesRequested } = useValues();
  const [tags, setTags] = useState([]);
  const selectRef = useRef(null);
  onAllOrganizationValuesRequested();

  const organizationValueList = Object.keys(organizationValues).map(
    key => ({ value: organizationValues[key].id, label: organizationValues[key].name, categoryIcon: "diamond" })
  );
  organizationValueList.sort((a, b) => a.name?.localeCompare(b.name));

  const onSelectedGroupsChange = value => {
    setTags(value);
    onValueSelected(value, selectRef.current.offsetHeight);
  };

  return (
    <div className="Select-Tags__Container" ref={selectRef}>
      <SelectField
        className="share-with-field"
        creatableLabel={t("Create a tag")}
        name="allOptions"
        options={organizationValueList}
        placeholder={t("Tag organizational values")}
        multiple
        onChange={onSelectedGroupsChange}
        value={tags}
      >
        <Icon icon="tags" />
      </SelectField>
    </div>
  );
};

export default RecognizeAddValue;
